'use strict';

var $brandsMenuWrapper = $('#brandsMenuWrapper');
var $brandsMenu = $brandsMenuWrapper.find('.header-menu-brand-wrapper');

var BrandsMenu = {
  scrollToBrand: function scrollToBrand(event) {
    event.preventDefault();

    var href = $(this).attr('href');
    var $scrollTo = $(href);

    if (!$scrollTo.length) {
      return false; //safe check, before ajax success
    }

    $brandsMenu.animate(
      {
        scrollTop: $scrollTo.offset().top - $brandsMenu.offset().top + $brandsMenu.scrollTop()
      },
      90
    );
  }
};

$brandsMenuWrapper
  .find('.header-menu-letter-wrapper a')
  .on('mouseover click', BrandsMenu.scrollToBrand);
